import React from 'react';
import { Nav, FAQAccordion, Reveal } from '@components';
import videoBitMob from '../../assets/videos/2-mob.mp4';
import videoBit from '../../assets/videos/2.mp4';
import picture from '../../assets/images/picture.png';
import mock from '../../assets/images/mock.png';
import { images } from '../../data';
import Slider from 'react-infinite-logo-slider';
import telegram from '../../assets/logos/telegram.svg';
import atSign from '../../assets/logos/at-sign.svg';
import { useScrollToHash } from '../../hooks/useScrollToHash'
import { ChatModal } from '@home_components';
import { Link } from 'react-router-dom';

const featuresList = [
  {
    title: 'Decentralized',
    description:
      'ProWebTrade is a decentralized exchange that allows users to trade cryptocurrencies, tokens, and other digital assets. It is built on the Ethereum blockchain and uses smart contracts to facilitate trading without the need for a centralized authority.',
  },
  {
    title: 'Secure',
    description:
      'ProWebTrade uses the latest security technology to ensure that your funds and personal information are safe. We take security very seriously and have implemented a number of measures to protect your assets.',
  },
  {
    title: 'Fast',
    description:
      'ProWebTrade is designed to be fast and efficient, so you can make trades quickly and easily. Our platform is built on the latest technology to ensure that trades are executed as quickly as possible.',
  },
  {
    title: 'Low fees',
    description:
      'ProWebTrade charges a small fee for each trade. The fee is based on the size of the trade and is used to cover the cost of running the exchange. We believe in transparent pricing and have no hidden fees.',
  },
  {
    title: 'Trade a wide range of assets',
    description:
      'ProWebTrade supports a wide range of assets, including cryptocurrencies, tokens, and other digital assets. You can trade all of these assets on a single platform, making it easy to diversify your portfolio.',
  },
  {
    title: 'AI and Machine Learning',
    description:
      'ProWebTrade is powered with the latest AI and Machine Learning technologies to give you the best trading experience. Our algorithms analyze market data in real-time to help you make informed trading decisions.',
  },
];

const faq_list = [
  {
    question: 'What is ProWebTrade?',
    answer:
      'ProWebTrade is a decentralized exchange that allows users to trade cryptocurrencies, tokens, and other digital assets. It is built on the Ethereum blockchain and uses smart contracts to facilitate trading without the need for a centralized authority.',
  },
  {
    question: 'How do I get started?',
    answer:
      'To get started, you will need to create an account and deposit funds. Once you have funds in your account, you can start trading.',
  },
  {
    question: 'What assets can I trade?',
    answer:
      'ProWebTrade supports a wide range of assets, including cryptocurrencies, tokens, and other digital assets.',
  },
  {
    question: 'How do I deposit and withdraw funds?',
    answer:
      'You can deposit and withdraw funds using a variety of methods, including bank transfer, credit card, and cryptocurrency.',
  },
  {
    question: 'What are the fees?',
    answer:
      'ProWebTrade charges a small fee for each trade. The fee is based on the size of the trade and is used to cover the cost of running the exchange.',
  },
];

const CardItem = ({ title, description }) => {
  return (
    <div className="flex flex-col p-7 border-[1px] border-[#3b3b3b] rounded-2xl bg-[#000000] backdrop-blur-[2rem] gap-5">
      <h1 className="text-xl">{title}</h1>
      <p className="text-[#a3a3a3] text-sm font-extralight leading-[160%]">
        {description}
      </p>
    </div>
  );
};

const Home = () => {
  const [openChat, setOpenChat] = React.useState(false);
  const [videoSrc, setVideoSrc] = React.useState(
    window.innerWidth < 768 ? videoBitMob : videoBit,
  );

  useScrollToHash()

  const disableScroll = () => {
    document.body.style.overflow = 'hidden';
  };
  const enableScroll = () => {
    document.body.style.overflow = 'auto';
  };

  React.useEffect(() => {
    const updateVideoSource = () => {
      if (window.innerWidth < 768) {
        setVideoSrc(videoBitMob);
      } else {
        setVideoSrc(videoBit);
      }
    };

    window.addEventListener('resize', updateVideoSource);
    return () => window.removeEventListener('resize', updateVideoSource);
  }, []);

  React.useEffect(() => {
    if (openChat) {
      disableScroll();
    } else {
      enableScroll();
    }
  }, [openChat]);

  return (
    <div className="overflow-x-hidden">
      {openChat && (
        <div className="fixed w-full md:w-auto bottom-0 md:max-w-[500px] md:right-4 md:bottom-4 overflow-y-auto z-50">
          <ChatModal closeChat={() => setOpenChat(false)} />
        </div>
      )}
      {/* floating chat fab */}

      <div className="fade w-[80vw] sm:w-[50vw] aspect-square rounded-full absolute z-0 left-[10vw] sm:left-[25vw] -top-[25vw] blur-[10rem]"></div>
      <Nav />
      <video
        src={videoSrc}
        playsInline
        autoPlay
        muted
        loop
        className="h-[100vh] w-[100vw] object-cover opacity-[.4] fixed z-[-2] top-0"
      />

      <div className="mt-bg-transparent flex flex-col items-center justify-between z-[3] mt-[120px] mb-12 md:mb-20">
        {/* Content Section */}
        <div className="flex flex-col items-center justify-center w-[100vw] gap-[2rem] px-4 flex-grow">
          <Reveal>
            <div className="px-7 py-4 border-2 border-[#ffffff44] rounded-full bg-[#ffffff22] backdrop-blur-[2rem]">
              <h1 className="text-sm">TRADE SMARTER, NOT HARDER</h1>
            </div>
          </Reveal>
          <Reveal classNamesOther="max-w-[80%]">
            <h1 className="text-white text-center text-3xl md:text-7xl leading-[140%] font-extralight">
              Unleash the Power of the Future with the Ultimate ProWebTrade Platform!
            </h1>
          </Reveal>
          <Reveal>
            <p className="text-center font-extralight text-lg md:text-xl">
              Step into the future with ProWebTrade
              <br className="hidden md:block" />
              powered by state-of-the-art AI and Machine Learning for a trading
              experience that’s as intelligent as it is intuitive
            </p>
          </Reveal>
          <Reveal>
            <div className="flex flex-col gap-6 mt-6" id="contacts">
              <Link
                className="bg-[#fff] text-black px-2 py-2 rounded-full cursor-pointer flex items-center gap-2 pr-3"
                to='https://t.me/ProWebTradeclientsupport'
              >
                <img src={telegram} alt="" className="h-[2rem]" />
                Join us on Telegram
              </Link>
              <Link
                className="bg-[#fff] text-black px-2 py-2 rounded-full cursor-pointer flex items-center gap-2 pr-3"
                to='mailto:support@prowebtrade.com'
              >
                <img src={atSign} alt="" className="h-[2rem]" />
                support@prowebtrade.com
              </Link>
            </div>
          </Reveal>
        </div>

        {/* Slider Section */}
        <div className="w-full flex justify-center mt-20">
          <Reveal>
            <Slider duration={40} pauseOnHover={true} blurBorders={false}>
              {images.map(({ id, image }) => (
                <Slider.Slide key={id}>
                  <img src={image} alt={id} className="w-[4rem] md:w-[7rem]" />
                </Slider.Slide>
              ))}
            </Slider>
          </Reveal>
        </div>
      </div>
      <div className="flex flex-col xl:flex-row items-center justify-between px-[5vw] md:px-[10vw] gap-[5vw] mb-12 md:mb-20" id='about'>
        <Reveal>
          <img src={mock} alt="" className="h-[510px] object-contain flex-1" />
        </Reveal>
        <Reveal>
          <p className="text-white font-extralight text-lg md:text-4xl text-left leading-[130%]">
            ProWebTrade is a decentralized cryptocurrency trading platform that
            enables secure, fast, and transparent trading of digital assets.
            Powered by AI and smart contracts, it eliminates intermediaries,
            offering a trustful and efficient trading experience. Whether you're
            a beginner or an expert, ProWebTrade provides the tools to navigate
            the crypto world with confidence.
          </p>
        </Reveal>
      </div>

      <div className="mb-12 md:mb-20">
        <Reveal log={true}>
          <p className="text-white font-extralight text-3xl md:text-6xl leading-[130%] text-left px-[5vw] md:px-[10vw] pb-[3rem]">
            Why using ProWebTrade?
          </p>
        </Reveal>

        <Reveal>
          <div className="grid grid-cols-1 md:grid-cols-3 px-[5vw] md:px-[10vw] gap-5">
            {featuresList.map((feature, index) => (
              <CardItem
                key={index}
                title={feature.title}
                description={feature.description}
              />
            ))}
          </div>
        </Reveal>
        {/* <Slider width="10rem" duration={60} pauseOnHover={true} blurBorders={false}> */}
      </div>

      <div className="w-full px-[5vw] md:px-[10vw] mb-12 md:mb-20" id='faq'>
        <Reveal>
          <p className="text-white font-extralight text-3xl md:text-6xl leading-[130%] text-left pb-[3rem]">
            Frequently Asked Questions
          </p>
          <FAQAccordion faqs={faq_list} />
        </Reveal>
      </div>

      <div className="w-full px-[5vw] md:px-[10vw] flex flex-col items-center" id='contacts'>
        <Reveal>
          <div className='flex flex-col items-center'>
            <p className="text-white font-extralight text-3xl md:text-6xl leading-[130%] text-center">
            What are you waiting for?
            <br />
            Start trading now!
          </p>
          <button
            className="bg-[#fff] text-black px-6 py-3 rounded-full cursor-pointer flex items-center gap-2 mt-[2rem]"
            onClick={() => (window.location.href = '/dashboard/?view=trading')}
          >
            Start Trading
          </button>
          <img src={picture} className="w-[90vw] md:w-[80vw]" />
          </div>
        </Reveal>
      </div>
      <footer className="w-full flex items-center justify-center pb-[1rem]">
        <p>2025 &copy; ProWebTrade&trade;</p>
      </footer>
    </div>
  );
};

export default Home;
